module.exports = __webpack_public_path__ + "static/media/wpc-door.59e6ad35.jpg";